module.exports = __webpack_public_path__ + "img/faming7.440d5d5e.png";